import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';



const TestPayment = () => {

    const [shippingAddress, setShippingAddress] = useState("");
    const navigate=useNavigate();
    const amount=1200;

    // Object 1: Order (Billing info)
    const invoice = {
    address: "asdasdas",
    city: "asdasda",
    company_name: "asdasdasd",
    email: "asdadsa",
    name: "Jámbor",
    payment: "bankcard",
    phone: "1231312",
    plus: 726,
    tax: "dadsad",
    zip: "asdada"
    };

    // Object 2: Shipping (Empty shipping info)
    const shipping = {
    address: "",
    city: "",
    name: "",
    phone: "",
    zip: ""
    };

    // Array: Cart items
    const cart = [
    {
        id: 4,
        color: "Átlátszó",
        image: "33.jpg",
        item: "Nyálszívó",
        price: 1499,
        quantity: "1"
    }
    ];

    useEffect(() => {
            if (shipping) {
                const formatted = `${shipping.name};${shipping.address};${shipping.city};${shipping.zip};${shipping.phone}`;
                setShippingAddress(formatted);
            }
    }, [shipping]);

    const handlePayment = async () => {
        if (invoice.payment=='bankcard') {
            try {
                const API = process.env.REACT_APP_BACKEND_URL;
                const order = await axios.post(`${API}/order`,{
                    name: invoice.name,
                    vat_number: invoice.vat_number,
                    address:invoice.address,
                    postcode:invoice.postcode,
                    city:invoice.city,
                    phone: invoice.phone,
                    email: invoice.email,
                    price: amount,
                    status: "pending",
                    cart: cart,
                    shipping: shippingAddress
                })
                const orderId=order.data.order_id
                console.log(order.data.order_id)
                const response = await axios.post(`${API}/pay`, {
                    order_id: orderId,
                    total_amount: amount
                });

                console.log(response.data)
    
                // Redirect to Raiffeisen's Payment Page
                const { paymentUrl, paymentData } = response.data;
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = paymentUrl;
    
                Object.entries(paymentData).forEach(([key, value]) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
    
                document.body.appendChild(form);
                form.submit();
                
            } catch (error) {
                console.error('Payment error:', error);
            }
        } else {
            try {
                const API = process.env.REACT_APP_BACKEND_URL;
                const order = await axios.post(`${API}/order`,{
                    name: invoice.name,
                    vat_number: invoice.vat_number,
                    address:invoice.address,
                    postcode:invoice.postcode,
                    city:invoice.city,
                    phone: invoice.phone,
                    email: invoice.email,
                    price: amount,
                    status: "pending",
                    cart: cart,
                    shipping: shippingAddress
                })
                const orderId=order.data.order_id
                navigate('/rendeles-visszaigazolas', {state: {orderId: orderId, method: invoice.payment, amount: amount}});
            } catch (error) {
                console.error('Payment error:', error);
            }
        }
        
    };

    return <button onClick={handlePayment}>Fizetés tesztelése</button>;
}

export default TestPayment